<div class="container-fluid">
  <div>
    <h2 class="light-bold">Copiar asistencias de una sesión a otra</h2>
  </div>

  <h3 class="light-bold mb-0">Busqueda de sesión</h3>
  <div class="text-muted small">
    Busca la sesión a la que enviarás las asistencias. Las sesiones deben
    coincidir en el tipo de QR y el número de partes.
  </div>
  <hr />

  <div class="row gx-2 mb-2">
    <div class="col-12">
      <app-year-session-selector
        [yearList]="yearList"
        [sessions]="sessions"
        [selectedYear]="selectedYear"
        [selectedSessionId]="selectedTargetSession?.Id ?? null"
        [isLoadingSessions]="isLoadingSessions"
        (yearChange)="onYearChange($event)"
        (sessionChange)="onTargetSessionChange($event)">
      </app-year-session-selector>
    </div>
  </div>

  <div *ngIf="selectedTargetSession" class="alert alert-info py-2 mt-3">
    Se copiarán las asistencias de la sesión
    <strong>{{ sourceSessionName }}</strong>
    a:
    <strong>
      {{ selectedTargetSession.IdLocalizador }} -
      {{ selectedTargetSession.titulo }}
    </strong>
  </div>

  <div class="d-flex justify-content-center align-content-center mb2 mt-4">
    <div class="col-3 p-1">
      <button
        class="btn btn-primario"
        [disabled]="!selectedTargetSession || isSameSession"
        (click)="onConfirm()">
        <span> Copiar asistencias </span>
      </button>
    </div>
    <div class="col-3 p-1 mx-1">
      <button class="btn btn-secondary-cap" (click)="onCancel()">
        Cancelar
      </button>
    </div>
  </div>
</div>
